import React, { useEffect, useState } from 'react'

const LikertView = ({ onChange, selectedData, values, mode, disabled = false }) => {
    const weekendObject = {
        sunday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ],
        monday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ],
        tuesday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ],
        wednesday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ],
        thursday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ],
        friday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ],
        saturday: [
            {
                type: 1,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 2,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 3,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 4,
                weekendDay: 'full_day',
                isSelected: false
            },
            {
                type: 5,
                weekendDay: 'full_day',
                isSelected: false
            },
        ]
    }
    useEffect(() => {
        setWeekEndObjectState(values);
    }, [values])
    const [selectedValues, setSelectedValues] = useState(selectedData)
    const [weekEndObjectState, setWeekEndObjectState] = useState(values)
    useEffect(() => {
        if (values && Object.keys(values).length > 0) {
            setWeekEndObjectState(values);
        } else {
            setWeekEndObjectState({}); // Ensures state isn't undefined
        }
    }, [values]);
    const handleCheckWeekend = (e, week, weekDayIdx, isCheckbox) => {
        let name = e.target.name
        let value
        if (isCheckbox) {
            value = e.target.checked
        } else {
            value = e.target.value
        }
        let duplicateWeekendObject = weekEndObjectState
        duplicateWeekendObject[week][weekDayIdx][name] = value
        setWeekEndObjectState({ ...duplicateWeekendObject })
        onChange(duplicateWeekendObject)
    }

    return (
        <div className='border border-gray-300 rounded mt-5'>
            <div className="grid grid-cols-7 grid-flow-row ">
                <div className="row-span-2 col-span-1 flex items-center justify-center border-r border-b border-gray-300 text-xl font-semibold">
                    Days
                </div>
                <div className='col-span-6 row-span-2'>
                    <div className="col-span-6 text-center py-2 border-b border-gray-300 font-semibold text-xl">Weeks</div>
                    <div className="col-span-6">
                        <div className='grid grid-cols-5'>
                            <div className=' text-center border-r border-b py-2 border-gray-300'>1st</div>
                            <div className=' text-center border-r border-b py-2 border-gray-300'>2nd</div>
                            <div className=' text-center border-r border-b py-2 border-gray-300'>3rd</div>
                            <div className=' text-center border-r border-b py-2 border-gray-300'>4th</div>
                            <div className=' text-center border-b py-2'>5th</div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='grid-container'>
            {weekEndObjectState && Object.keys(weekEndObjectState).length > 0 ? (
    Object.keys(weekEndObjectState).map((weekName, weekIdx) => (
        <div key={weekIdx} className="grid grid-cols-7 grid-flow-row">
            <div className="col-span-1 capitalize flex items-center justify-center border-r border-b border-gray-300 font-semibold text-lg">
                {weekName}
            </div>
            <div className='col-span-6'>
                <div className='grid grid-cols-5'>
                    {weekEndObjectState[weekName]?.map((weekDaysDetail, weekDaysIdx) => {
                        if (!weekDaysDetail) return null;
                        const { isSelected, weekendDay } = weekDaysDetail;
                        return (
                            <div key={weekDaysIdx} className='text-center border-r border-b py-2 border-gray-300'>
                                <div className='flex items-center space-x-4 px-4'>
                                    <input type="checkbox" name='isSelected' disabled={disabled} checked={isSelected} 
                                        onChange={(e) => handleCheckWeekend(e, weekName, weekDaysIdx, true)} 
                                    />
                                    <select disabled={!isSelected || disabled} 
                                        className='hidden lg:block input disabled:opacity-30' 
                                        name='weekendDay' value={weekendDay || "full_day"} 
                                        onChange={(e) => handleCheckWeekend(e, weekName, weekDaysIdx, false)}>
                                        <option value="full_day">Full Day</option>
                                        <option value="first_half">1st Half</option>
                                        <option value="second_half">2nd Half</option>
                                    </select>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    ))
) : (
    <p className="text-center py-4 text-gray-500">No weekend definition available.</p>
)}

            </div>
        </div>
    )
}

export default LikertView